import { styled } from '@/stitches.config';

import { Box } from '@base-app';
import { ReactComponent as RightArrowIcon } from '@assets/icons/arrow-right.svg';

export const StlyledSampleTitleContainer = styled(Box, {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
});

export const StyledContent = styled(Box, {
  alignItems: 'center',
  display: 'flex',
});

export const StyledRightLabel = styled('button', {
  background: 'transparent',
  border: 'none',
  color: '$darkBlue200',
  cursor: 'pointer',
  display: 'flex',
  fontSize: '$sm',
  fontWeight: '$normal',
});

export const StyledRightArrowIcon = styled(RightArrowIcon, {
  color: '$darkBlue200',
  display: 'flex',
  height: '$4',
  width: '$5',
});

export const StyledSeparator = styled(Box, {
  borderRight: '$borderWidths$1 solid $seafoam500',
  margin: '0 $7 0 $6',
  minHeight: '$6',
});

export const StyledIconContainer = styled(Box, {
  marginRight: '$3',
  display: 'flex',
});
